import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { authGuard } from './core/auth/auth.guard';
import { mustChangePasswordGuard } from './core/auth/must-change-password.guard';
import { changePasswordPageGuard } from './core/auth/change-password-page.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'change-password',
    canActivate: [changePasswordPageGuard],
    loadComponent: () => import('./features/auth/change-password/change-password.component').then(m => m.ChangePasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard, mustChangePasswordGuard],
    runGuardsAndResolvers: 'always',
    children: [
      { path: '', redirectTo: 'facesheet', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/user-management/user-management.routes').then(m => m.USER_MANAGEMENT_ROUTES)
      },
      {
        path: 'providers',
        loadChildren: () => import('./features/provider/provider.routes').then(m => m.PROVIDER_ROUTES)
      },
      {
        path: 'facesheet',
        loadChildren: () => import('./features/face-sheet/face-sheet.routes').then(m => m.FACE_SHEET_ROUTES)
      },
      {
        path: 'writeoff',
        loadChildren: () => import('./features/write-off/write-off.routes').then(m => m.WRITE_OFF_ROUTES)
      },
      {
        path: 'authorization',
        loadChildren: () => import('./features/authorization/authorization.routes').then(m => m.AUTHORIZATION_ROUTES)
      }
    ]
  },
  { path: '_blank', children: [] },
  { path: '**', redirectTo: '' }
];
